import { Color, ColorPickerState } from "../types";

interface IPayload {
    payload: Color;
}

export const setCurrentColor = (state: ColorPickerState, { payload }: IPayload): void => {
    state.currentColor = payload;
};
